// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2064":"a7c9bf36","2118":"a7c9bf36","2711":"a7c9bf36","4093":"a7c9bf36","4632":"9e962f7a","7204":"9e962f7a","7539":"a7c9bf36","7666":"3d218056","8263":"6c51734b","8688":"b3249b30"}[chunkId] + ".chunk.css";
};